import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {Roles, Sex} from "shared/user";

@Injectable({
    providedIn: 'root'
})
export class HttpService {
    private urls = {
        images_api: '/images/upload',
        setup_api: '/api/auth/setup',
        resend_confirmation_api: '/api/registration/resend_confirmation',
        registration_api: '/api/registration',
        confirmation_api: '/api/registration/confirm',
        restore_api: '/api/restore/start',
        restore_finish_api: '/api/restore/finish',
        administration_root_api: '/api/administration',
        test_api: '/api/service/test',
    }

    constructor(private http: HttpClient) {
    }

    private get host(): string {
        return environment.api
    }

    sendImage(image: ArrayBuffer, session: string): Observable<Object> {
        const formData = new FormData();
        formData.append('session', session);
        formData.append('image', new Blob([image]));

        const url = `${this.host}${this.urls.images_api}`

        return this.http.post(url, formData, {
            withCredentials: false,
            reportProgress: true,
            observe: 'events'
        });
    }

    setup(login: string, version: string, hash: string) {
        const url = `${this.host}${this.urls.setup_api}`
        return this.http.post(url, {
            login: login,
            version: version,
            hash: hash,
        })
    }

    resendConfirmationEmail(login: string) {
        const url = `${this.host}${this.urls.resend_confirmation_api}`
        return this.http.post(url, {
            login: login
        })
    }

    registration(login: string, sex: Sex, email: string, password: string, recapthca: string): Observable<Object> {
        const url = `${this.host}${this.urls.registration_api}`
        return this.http.post(url, {
            login: login,
            sex: sex,
            email: email,
            password: password,
            recapthca: recapthca
        })
    }

    confirm(email: string, code: string): Observable<Object> {
        const url = `${this.host}${this.urls.confirmation_api}`
        return this.http.post(url, {
            email: email,
            code: code
        })
    }

    restoreStart(email: string, recaptchaToken: string) {
        const url = `${this.host}${this.urls.restore_api}`
        return this.http.post(url, {
            email: email,
            recapthca: recaptchaToken
        })
    }

    restoreFinish(email: string, code: string, password: string) {
        const url = `${this.host}${this.urls.restore_finish_api}`
        return this.http.post(url, {
            email: email,
            code: code,
            newPassword: password
        })
    }

    testRequest(): Observable<HttpResponse<Object>> {
        const url = `${this.host}${this.urls.test_api}`
        return this.http.get(url, {observe: "response"})
    }

    searchUser(session: string, login: string) {
        const url = `${this.host}${this.urls.administration_root_api}/search_user`
        return this.http.post(url, {
            session: session,
            login: login
        })
    }

    changeRoles(session: string, login: string, roles: Array<Roles>) {
        const url = `${this.host}${this.urls.administration_root_api}/change_roles`
        return this.http.post(url, {
            session: session,
            login: login,
            roles: roles
        })
    }
}
